export const BUTTON_CATEGORY_KEY = 'base' as const;
export const BUTTON_PARENT_COMPONENT_KEY = 'contextMenu' as const;
export const BUTTON_COMPONENT_KEY = 'button' as const;
